import axios from "axios";
import JwtService from "@/common/jwt.service";

const state = {
  errors: null,
  userId: localStorage.getItem("userId") || null,
  isAuthenticated: !!JwtService.getAccessToken(),
  permissions: localStorage.getItem("permissions") || [],
};

const getters = {
  user: (state) => state.userId,
  isAuthenticated: (state) => !!state.isAuthenticated,
  permissions: (state) => state.permissions,
};

const actions = {
  login({ commit, dispatch }, user) {
    return new Promise((resolve, reject) => {
      axios
        .post(process.env.VUE_APP_API + "token/", user)
        .then((response) => {
          commit("setAuth", response);
          resolve(response);
        })
        .catch((error) => {
          commit("authError", error);
          reject(error);
        });
    });
  },

  refresh({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .post(process.env.VUE_APP_API + "token/refresh/", {
          refresh: JwtService.getRefreshToken(),
        })
        .then((response) => {
          commit("setAuth", response);
          resolve(response);
        })
        .catch((error) => {
          commit("authError", error);
          reject(error);
        });
    });
  },

  logout({ commit }) {
    commit("purgeAuth");
  },
};

const mutations = {
  setAuth(state, payload) {
    state.isAuthenticated = true;
    state.userId = JSON.parse(atob(payload.data.access.split(".")[1]))[
      "user_id"
    ];
    state.permissions = payload.data.permissions;
    state.errors = {};
    JwtService.saveAccessToken(payload.data.access);
    JwtService.saveRefreshToken(payload.data.refresh);
    localStorage.setItem("userId", state.userId);
    if (state.permissions) {
      localStorage.setItem("permissions", JSON.stringify(state.permissions));
    }
  },

  authError(state, error) {
    state.errors = error;
  },

  purgeAuth(state) {
    JwtService.destroyAccessToken();
    JwtService.destroyRefreshToken();
    localStorage.removeItem("userId");
    localStorage.removeItem("permissions");
    state.isAuthenticated = false;
    state.userId = null;
    state.permissions = null;
    state.errors = null;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
